<template>
    <MainSlot :background_image_url="background_image_url"
              :body_classes="body_classes"
              :show_footer="true">
        <div class="container">
            <div class="row">
                <div class="group_image col m12" :style="{background: group_image_background}">
                    <div class="title">
                        {{ group.title }}
                    </div>
                </div>

                <div v-if="!group.is_private && (group.events_count || group.posts_count)" class="group_tabs">
                    <div v-if="group.posts_count" class="tab">
                        {{ group.posts_count + ' ' + $t('public["Posts"]') }}
                    </div>
                    <div v-if="group.events_count" class="tab">
                        {{ group.events_count + ' ' + $t('public["Events"]') }}
                    </div>
                </div>

                <PublicDescription v-if="!group.is_private" :content="group.description"/>

                <div v-if="group.is_private" class="private_group">

                    <PrivateGroupIcon/>

                    <div class="message">
                        {{ $t('public["It’s a private group."]') }}
                    </div>

                </div>

                <PublicInfoButtonsGroup style="margin-top: -20px;"/>
            </div>
        </div>
    </MainSlot>
</template>

<script>
import PublicDescription from "../components/PublicDescription";
import PublicInfoButtonsGroup from "../components/PublicInfoButtonsGroup";
import {mapMutations} from "vuex";
import PrivateGroupIcon from "../components/svg/PrivateGroupIcon";

export default {
    data() {
        return {
            is_invalid_group_id: false,
            group: {}
        }
    },
    async created() {
        const {group_id} = this;
        if (Number.isNaN(+group_id)) {
            await this.$router.push('/404');
            return;
        }
        await this.setLogged(false);
        await this.loadGroupInfo()
    },
    methods: {
        ...mapMutations([
            'setLogged',
            'setLoading',
        ]),
        async loadGroupInfo() {
            try {
                this.setLoading(true);
                const response = await this.$http.get(`${this.$http.apiUrl()}public/groups/${this.group_id}`);
                const group = response?.data?.data?.group || {}
                if (+this.group_id === +group?.id) {
                    this.group = group;
                }
            } catch (e) {
                console.log(e);
            } finally {
                this.setLoading(false);
            }
        }
    },
    computed: {
        background_image_url() {
            return this.group?.image_url || '';
        },
        body_classes() {
            return 'profile';
        },
        group_image_background() {
            const url = this.background_image_url || '';
            return `linear-gradient(180deg, rgba(58, 1, 67, 0) 45.06%, rgba(58, 1, 67, 0.5) 82.5%, rgba(58, 1, 67, 0.6) 100%), #fff url(${url}) no-repeat center / cover`;
        }
    },
    props: {
        group_id: {
            required: true,
            type: [Number, String],
        }
    },
    components: {PrivateGroupIcon, PublicInfoButtonsGroup, PublicDescription},
    metaInfo: {
        title: 'Public group info',
    },
    name: "PublicGroupInfo",
}
</script>

<style lang="scss" scoped>

.private_group {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    padding: 60px 0;

    .message {
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 18px;
        color: #B5BEDE;
        padding: 12px 0;
    }
}

.group_tabs {
    margin: 30px 0;
    background: #FFFFFF;
    box-shadow: 0px 3px 8px rgba(58, 1, 67, 0.05);
    border-radius: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;

    .tab {
        width: 50%;
        padding: 16px;
        gap: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 18px;
        color: #000000;
    }
}

.group_image {
    height: 350px;
    max-height: 350px;
    width: auto;
    margin: -300px 0 30px;
    position: relative;
    display: flex;
    align-items: flex-end;
    overflow: hidden;
    border-radius: 12px;
    padding: 15px;
    filter: drop-shadow(3px 6px 12px rgba(58, 1, 67, 0.15));

    @media screen and (max-width: 767px) {
        margin: -90px 0 30px;
        width: 100%;
    }

    .title {
        width: 100%;
        display: flex;
        align-items: flex-start;
        flex-direction: column;
        position: relative;
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 29px;
        color: #FFFFFF;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.25);
    }
}

.container {
    width: 540px;
    max-width: 94vw;
}

.row {
    min-height: calc(100vh - 490px);

    @media screen and (max-width: 767px) {
        min-height: calc(100vh - 190px);
    }
}
</style>
